import ApexChart from './ApexChart';

const Charts = { ApexChart };

export default Charts;
